import { Checkbox } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useSendAsEmailForm } from '../../../../../../contexts/sendAsEmailFormContext'
import { useTrackSendAsEmail } from '../../../../../../hooks/useTrackSendAsEmail'

export const SendCopyToMyself = (): ReactElement | null => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { sendAsEmailForm } = useSendAsEmailForm()
  const { trackSendAsEmail } = useTrackSendAsEmail()
  const { FormItem } = sendAsEmailForm

  const handleSendCopyToMyselfCheckboxChange = useCallback(
    (checked: boolean) => trackSendAsEmail('Send copy to myself toggled', { checked }),
    [trackSendAsEmail],
  )

  if (!organization?.email) {
    return null
  }

  return (
    <FormItem
      name="shouldSendCopyToMyself"
      render={({ field: { value, onChange, ...props } }) => {
        return (
          <Checkbox
            {...props}
            checked={value}
            onChange={(event) => {
              onChange(event)
              handleSendCopyToMyselfCheckboxChange(event.target.checked)
            }}
          >
            {t('external_invoices.send_as_email.modal.form.field.send_copy_to_myself.label', {
              email: organization.email,
            })}
          </Checkbox>
        )
      }}
    />
  )
}
